import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  signal,
} from '@angular/core';
import {
  Clipboard,
} from '@angular/cdk/clipboard';

import {
  IconComponent,
} from '../design-system/components/icon/icon.component';

@Component({
  selector: 'lib-linkout',
  standalone: true,
  imports: [
    IconComponent,
  ],
  templateUrl:
    './linkout.component.html',
  styleUrl:
    './linkout.component.scss',
  changeDetection:
    ChangeDetectionStrategy.OnPush,
})
export class LinkoutComponent {
  private readonly clipboard =
    inject(Clipboard);

  readonly recordId =
    input.required<string>();

  readonly recordLabel =
    input('record ID');

  readonly externalUrl =
    input<string | null>(null);

  readonly allowCopy =
    input(true);

  readonly showShelterluvHelp =
    input(false);

  readonly isAdopterUnknown =
    input(false);

  readonly app =
    input<number>();

  readonly copied =
    signal(false);

  copyRecordId(): void {
    const normalizedId =
      this.recordId().trim();

    if (!normalizedId) {
      return;
    }

    const didCopy =
      this.clipboard.copy(
        normalizedId,
      );

    if (!didCopy) {
      return;
    }

    this.copied.set(true);

    window.setTimeout(
      () => this.copied.set(false),
      1500,
    );
  }
}
